import { render, staticRenderFns } from "./ViewCarousel.vue?vue&type=template&id=a870875a&scoped=true"
import script from "./ViewCarousel.vue?vue&type=script&lang=js"
export * from "./ViewCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a870875a",
  null
  
)

export default component.exports